import { useTranslation } from 'react-i18next';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import DarkModeOutlinedIcon from '@mui/icons-material/DarkModeOutlined';
import LightModeOutlinedIcon from '@mui/icons-material/LightModeOutlined';
import { useAppTheme } from '@/hooks/useAppTheme';

export function ThemeToggle() {
  const { t } = useTranslation();
  const { mode, toggleThemeMode } = useAppTheme();
  const isDark = mode === 'dark';
  const label = isDark ? t('layout.switchToLightMode') : t('layout.switchToDarkMode');

  return (
    <Tooltip title={label}>
      <IconButton onClick={toggleThemeMode} size="small" color="inherit" aria-label={label}>
        {isDark ? <LightModeOutlinedIcon /> : <DarkModeOutlinedIcon />}
      </IconButton>
    </Tooltip>
  );
}
